<div class="margin-bottom-1rem full-w center-contents-h">
    <slot />
</div>
